import humanizeDuration from 'humanize-duration'
import { isNil, isNull, isUndefined } from 'lodash'
import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

const shortFrenchhHumanizer = humanizeDuration.humanizer({
    language: 'shortFr',
    languages: {
        shortFr: {
            y: () => 'a',
            mo: () => 'mo',
            w: () => 'sem',
            d: () => 'j',
            h: () => 'h',
            m: () => 'min',
            s: () => 's',
            ms: () => 'ms',
        },
    },
})

const shortenHumanize = duration => {
    return shortFrenchhHumanizer(duration, { largest: 2, units: ['y', 'mo', 'w', 'd', 'h', 'm', 's', 'ms'] })
}

const getDate = (timestamp, format = 'DD/MM/YYYY') => {
    if (isUndefined(timestamp) || isNull(timestamp)) {
        return ''
    }
    return moment(timestamp).format(format)
}

const getDateExport = () => moment().format('YYYYMMDDHHmmss')
const getFullDate = timestamp => getDate(timestamp, 'DD/MM/YYYY HH:mm:ss')
const getFullDateMini = timestamp => getDate(timestamp, 'DD/MM/YYYY HH:mm')
const getHour = timestamp => getDate(timestamp, 'HH:mm:ss')
const getMiniDate = timestamp => getDate(timestamp, 'DD/MM/YY')
const getArticleFormat = timestamp => getDate(timestamp, 'DD MMM YYYY')
const getYear = timestamp => getDate(timestamp, 'YYYY')
const getMonthMiniYear = timestamp => getDate(timestamp, 'MM/YY')
const getMonthYear = timestamp => getDate(timestamp, 'MM/YYYY')
const getWeekYear = timestamp => getDate(timestamp, 'ww/YYYY')
const getDayMonth = timestamp => getDate(timestamp, 'DD/MM')
const getDayHour = timestamp => getDate(timestamp, 'DD/MM/YYYY:HH')
const getMiniYear = timestamp => getDate(timestamp, 'YY')

const getMonthList = () => [
    { value: 1, name: 'Janvier' },
    { value: 2, name: 'Février' },
    { value: 3, name: 'Mars' },
    { value: 4, name: 'Avril' },
    { value: 5, name: 'May' },
    { value: 6, name: 'Juin' },
    { value: 7, name: 'Juiller' },
    { value: 8, name: 'Août' },
    { value: 9, name: 'Septembre' },
    { value: 10, name: 'Octobre' },
    { value: 11, name: 'Novembre' },
    { value: 12, name: 'Decembre' },
]

const getMonth = (timestamp) => {
    const month = moment.unix(timestamp).month()
    switch (month) {
        case 0: return 'Janvier'
        case 1: return 'Février'
        case 2: return 'Mars'
        case 3: return 'Avril'
        case 4: return 'Mai'
        case 5: return 'Juin'
        case 6: return 'Juillet'
        case 7: return 'Août'
        case 8: return 'Septembre'
        case 9: return 'Octobre'
        case 10: return 'Novembre'
        default: return 'Décembre'
    }
}

const getTrimester = (timestamp) => {
    const month = moment.unix(timestamp).month()
    return Math.floor(month / 4) + 1
}

const getSemester = (timestamp) => {
    const month = moment.unix(timestamp).month()
    return month < 6 ? 1 : 2
}

const getDuration = (start, end, mode = 'days') => Math.trunc(moment.duration(moment(end).diff(moment(start))).as(mode))

const getStartMonthFromTrimester = (trimester) => {
    switch (trimester) {
        default: case 1:
            return 'Janvier'
        case 2:
            return 'Avril'
        case 3:
            return 'Juillet'
        case 4:
            return 'Octobre'
    }
}

const getEndMonthFromTrimester = (trimester) => {
    switch (trimester) {
        default: case 1:
            return 'Mars'
        case 2:
            return 'Juin'
        case 3:
            return 'Septembre'
        case 4:
            return 'Décembre'
    }
}

const REQUIRED_SIZE_NUM_VERSION = 4

const computeRangeLabel = (range, series) => {
    const [start, end] = range
    if (!isNil(start) && !isNil(end)) return `Du ${getDate(start)} au ${getDate(end)}`
    if (!isNil(start)) return `Depuis le ${getDate(start)}`
    if (!isNil(end)) return `Jusqu'au ${getDate(end)}`
    const allTs = series.flatMap(g => g.data.flatMap(s => s.data.map(([d]) =>
        typeof d === 'number' ? d : moment(d).valueOf(),
    )))
    if (!allTs.length) return null
    return `Du ${getDate(Math.min(...allTs))} au ${getDate(Math.max(...allTs))}`
}

const getDateWithNumVersion = (num) => {
    const tab = num.split('.')
    if (tab.length !== REQUIRED_SIZE_NUM_VERSION) return undefined
    const year = String(Number(tab[1]) + 2019)
    const day = tab[2]
    const hours = tab[3].slice(0, 2)
    const min = tab[3].slice(2, 4)

    const date = new Date(year)
    date.setDate(day)
    date.setHours(hours, min)

    return date.getTime()
}

export {
    getDateExport,
    getFullDate,
    getArticleFormat,
    getDate,
    getMiniDate,
    getYear,
    getHour,
    getMonthYear,
    getWeekYear,
    getMonthMiniYear,
    getMiniYear,
    getDayMonth,
    getFullDateMini,
    shortenHumanize,
    getDayHour,
    getMonthList,
    getMonth,
    getTrimester,
    getSemester,
    getDuration,
    getStartMonthFromTrimester,
    getEndMonthFromTrimester,
    getDateWithNumVersion,
    computeRangeLabel,
}
